

// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import { collection, getDocs } from "firebase/firestore";
// import { db } from "../firebase"; // Import your Firestore configuration
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const ViewRetakeTrainingResult = () => {
//   const { userId, trainingId } = useParams(); // Extract userId and trainingId from URL params
//   const [retakes, setRetakes] = useState([]); // User's retake attempts
//   const [questions, setQuestions] = useState([]); // Questions from trainings collection
//   const [loading, setLoading] = useState(true);

//   // Fetch retake data from Firestore
//   useEffect(() => {
//     const getRetakesAndQuestions = async () => {
//       try {
//         // Fetch retakes from users collection
//         const retakesCollectionRef = collection(
//           db,
//           "users",
//           userId,
//           "quizzes",
//           trainingId,
//           "retakes"
//         );
//         const retakesSnapshot = await getDocs(retakesCollectionRef);

//         // Fetch questions from trainings collection
//         const questionsCollectionRef = collection(db, `trainings/${trainingId}/questions`);
//         const questionsSnapshot = await getDocs(questionsCollectionRef);

//         if (!retakesSnapshot.empty && !questionsSnapshot.empty) {
//           // Extract retakes data
//           const retakesData = retakesSnapshot.docs.map((doc) => doc.data().attempts || []);
//           setRetakes(retakesData.flat()); // Flatten the array of attempts

//           // Extract questions data
//           const questionsData = questionsSnapshot.docs.map((doc) => ({
//             id: doc.id,
//             ...doc.data(),
//           }));
//           setQuestions(questionsData);
//         } else {
//           toast.info("No retakes or questions found for this quiz.");
//         }
//       } catch (error) {
//         toast.error("Error fetching data: " + error.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     getRetakesAndQuestions();
//   }, [userId, trainingId]);

//   // Helper function to get the user's answer for a specific question index
//   const getUserAnswer = (retake, index) => {
//     if (!Array.isArray(retake.answers)) {
//       return "Not answered"; // If answers is not an array
//     }
//     if (retake.answers[index] && retake.answers[index].id !== undefined) {
//       return retake.answers[index].id ? "True" : "False"; // Convert boolean to "True" or "False"
//     }
//     return "Not answered"; // If no answer found for this question
//   };

//   return (
//     <div className="container mt-3" style={{ fontFamily: "Arial, sans-serif", maxWidth: "800px" }}>
//       <h3>Retake Results for Training: {trainingId}</h3>

//       {loading ? (
//         <p>Loading...</p>
//       ) : (
//         <div>
//           {retakes.length > 0 ? (
//             retakes.map((retake, retakeIndex) => (
//               <div key={retakeIndex} className="mb-5">
//                 <h4>Retake {retakeIndex + 1}</h4>
//                 <p><strong>Score:</strong> {retake.score}</p>
//                 <p><strong>Completed At:</strong> {retake.completedAt}</p>

//                 <table className="table table-bordered">
//                   <thead>
//                     <tr>
//                       <th>Question</th>
//                       <th>Your Answer</th>
//                       <th>Correct Answer</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {questions.map((question, index) => {
//                       const userAnswer = getUserAnswer(retake, index); // Get user's answer
//                       const correctAnswer = question.answer ? "True" : "False"; // Convert correct answer to "True" or "False"

//                       return (
//                         <tr key={index}>
//                           <td>{question.text}</td> {/* Render question text */}
//                           <td
//                             style={{
//                               color: userAnswer === correctAnswer ? "green" : "red",
//                             }}
//                           >
//                             {userAnswer}
//                             {console.log(retake)}
//                           </td> {/* Render user's answer */}
//                           <td>{correctAnswer}</td> {/* Render correct answer */}
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>
//               </div>
//             ))
//           ) : (
//             <p>No retakes available.</p>
//           )}
//         </div>
//       )}
//     </div>

    
//   );
// };

// export default ViewRetakeTrainingResult;












// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import { doc, getDoc, collection, getDocs } from "firebase/firestore";

// import { db } from "../firebase"; // Import your Firestore configuration
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import trainer from "../assets/trainer.png"; // Assuming you have this asset for the logo
// import logo from "../assets/logo.png";

// const ViewRetakeTrainingResult = () => {
//   const { userId, trainingId } = useParams(); // Extract userId and trainingId from URL params
//   const [retakes, setRetakes] = useState([]); // User's retake attempts
//   const [questions, setQuestions] = useState([]); // Questions from training collection
//   const [userDetails, setUserDetails] = useState(null); // User's details
//   const [loading, setLoading] = useState(true);
//   const [trainingName, setTrainingName] = useState("");
//   const [trainingType, setTrainingType] = useState("");


//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       try {
//         // Fetch user details
//         const userDocRef = doc(db, "users", userId);
//         const userDocSnap = await getDoc(userDocRef);
//         if (userDocSnap.exists()) {
//           setUserDetails(userDocSnap.data());
//         } else {
//           toast.error("User not found!");
//         }

//         // Fetch retakes from Firestore
//         const retakesCollectionRef = collection(db, "users", userId, "quizzes", trainingId, "retakes");
//         const retakesSnapshot = await getDocs(retakesCollectionRef);

//         // Fetch training details
//         const trainingDoc = await getDoc(doc(db, "trainings", trainingId));
//         if (trainingDoc.exists()) {
//           setTrainingName(trainingDoc.data().name);
//           setTrainingType(trainingDoc.data().type); // true_false or mcq
//         } else {
//           toast.error("Training not found!");
//         }

//         // Fetch questions for the training
//         const questionsCollectionRef = collection(db, `trainings/${trainingId}/questions`);
//         const questionsSnapshot = await getDocs(questionsCollectionRef);
//         const questionsData = questionsSnapshot.docs.map((doc) => ({
//           id: doc.id,
//           ...doc.data(),
//         }));
//         setQuestions(questionsData);

//         if (!retakesSnapshot.empty) {
//           const retakesData = retakesSnapshot.docs.map((doc) => doc.data().attempts || []);
//           setRetakes(retakesData.flat()); // Flatten retakes array
//         } else {
//           toast.info("No retakes found.");
//         }
//       } catch (error) {
//         toast.error("Error fetching data: " + error.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [userId, trainingId]);

//   const formatDate = (dateString) => {
//     if (!dateString) return ''; // Handle empty or undefined date
//     const date = new Date(dateString);  // Convert string to Date object

//     const day = String(date.getDate()).padStart(2, '0');  // Get day and ensure 2 digits
//     const month = String(date.getMonth() + 1).padStart(2, '0');  // Get month (0-based, so add 1) and ensure 2 digits
//     const year = date.getFullYear();  // Get year

//     return `${day}/${month}/${year}`;  // Return formatted date as dd/mm/yyyy
//   };

//   if (loading) {
//     return (
//       <div className="container mt-3 text-center">
//         <img className="logo-img" src={trainer} alt="Bee's Care Ltd" />
//         <h2>Loading Retake Results...</h2>
//       </div>
//     );
//   }

//   if (!retakes.length || !questions.length) {
//     return (
//       <div className="container mt-3 text-center">
//         <img className="logo-img bee" src={logo} alt="Bee's Care Ltd" />
//         <h2>No Retakes Found for this Training.</h2>
//       </div>
//     );
//   }

//   return (
//     <div className="container mt-4" style={{ fontFamily: "Arial, sans-serif", maxWidth: "800px" }}>
//       <div className="text-center mb-4">
//         <img className="logo-img bee" src={logo} alt="Bee's Care Ltd" />
//         <h2>{trainingName} - Retake Results</h2>
//       </div>

//       {/* User's details */}
//       <div className="mb-3">
//         <label><strong>Name of Learner:</strong></label>
//         <input
//           type="text"
//           value={`${userDetails?.firstName} ${userDetails?.lastName || "Loading..."}`}
//           className="form-control"
//           readOnly
//         />
//       </div>

//       <div className="mb-3">
//         <label><strong>Organisation:</strong></label>
//         <input
//           type="text"
//           value="Bee's Care Ltd"
//           className="form-control"
//           readOnly
//         />
//       </div>

//       <div className="mb-3">
//         <label><strong>Course Date:</strong></label>
//         <input
//           type="text"
//           value={formatDate(retakes[0]?.completedAt) || "Loading..."}
//           className="form-control"
//           readOnly
//         />
//       </div>

//       {/* Retake Results */}
//       {retakes.map((retake, retakeIndex) => (
//         <div key={retakeIndex} className="mb-5">
//           <h4>Retake {retakeIndex + 1}</h4>
//           <p><strong>Score:</strong> {retake.score}</p>
//           <p><strong>Completed At:</strong> {retake.completedAt}</p>

//           <table className="table table-bordered">
//             <thead>
//               <tr>
//                 <th>Question</th>
//                 <th>Your Answer</th>
//                 <th>Correct Answer</th>
//               </tr>
//             </thead>
//             <tbody>
//               {questions.map((question, index) => {
//                 const userAnswer = retake.answers?.[index] ? "True" : "False";
//                 const correctAnswer = question.answer ? "True" : "False";

//                 return (
//                   <tr key={index}>
//                     <td>{question.text}</td>
//                     <td
//                       style={{
//                         color: userAnswer === correctAnswer ? "green" : "red",
//                       }}
//                     >
//                       {userAnswer}
//                     </td>
//                     <td>{correctAnswer}</td>
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </div>
//       ))}

//       <div className="text-center mt-4">
//         <p><strong>© Bee’s Care Ltd. All rights reserved.</strong></p>
//       </div>

//       <ToastContainer />
//     </div>
//   );
// };

// export default ViewRetakeTrainingResult;














































// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import { doc, getDoc, collection, getDocs } from "firebase/firestore";

// import { db } from "../firebase"; // Import your Firestore configuration
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import trainer from "../assets/trainer.png"; // Assuming you have this asset for the logo
// import logo from "../assets/logo.png";

// const ViewRetakeTrainingResult = () => {
//   const { userId, trainingId } = useParams(); // Extract userId and trainingId from URL params
//   const [retakes, setRetakes] = useState([]); // User's retake attempts
//   const [questions, setQuestions] = useState([]); // Questions from training collection
//   const [userDetails, setUserDetails] = useState(null); // User's details
//   const [loading, setLoading] = useState(true);
//   const [trainingName, setTrainingName] = useState("");
//   const [trainingType, setTrainingType] = useState(""); // true/false or mcq

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       try {
//         // Fetch user details
//         const userDocRef = doc(db, "users", userId);
//         const userDocSnap = await getDoc(userDocRef);
//         if (userDocSnap.exists()) {
//           setUserDetails(userDocSnap.data());
//         } else {
//           toast.error("User not found!");
//         }

//         // Fetch retakes from Firestore
//         const retakesCollectionRef = collection(db, "users", userId, "quizzes", trainingId, "retakes");
//         const retakesSnapshot = await getDocs(retakesCollectionRef);

//         // Fetch training details
//         const trainingDoc = await getDoc(doc(db, "trainings", trainingId));
//         if (trainingDoc.exists()) {
//           setTrainingName(trainingDoc.data().name);
//           setTrainingType(trainingDoc.data().type); // true_false or mcq
//         } else {
//           toast.error("Training not found!");
//         }

//         // Fetch questions for the training
//         const questionsCollectionRef = collection(db, `trainings/${trainingId}/questions`);
//         const questionsSnapshot = await getDocs(questionsCollectionRef);
//         const questionsData = questionsSnapshot.docs.map((doc) => ({
//           id: doc.id,
//           ...doc.data(),
//         }));
//         setQuestions(questionsData);

//         if (!retakesSnapshot.empty) {
//           const retakesData = retakesSnapshot.docs.map((doc) => doc.data().attempts || []);
//           setRetakes(retakesData.flat()); // Flatten retakes array
//         } else {
//           toast.info("No retakes found.");
//         }
//       } catch (error) {
//         toast.error("Error fetching data: " + error.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [userId, trainingId]);

//   const formatDate = (dateString) => {
//     if (!dateString) return ''; // Handle empty or undefined date
//     const date = new Date(dateString);  // Convert string to Date object

//     const day = String(date.getDate()).padStart(2, '0');  // Get day and ensure 2 digits
//     const month = String(date.getMonth() + 1).padStart(2, '0');  // Get month (0-based, so add 1) and ensure 2 digits
//     const year = date.getFullYear();  // Get year

//     return `${day}/${month}/${year}`;  // Return formatted date as dd/mm/yyyy
//   };

//   if (loading) {
//     return (
//       <div className="container mt-3 text-center">
//         <img className="logo-img" src={trainer} alt="Bee's Care Ltd" />
//         <h2>Loading Retake Results...</h2>
//       </div>
//     );
//   }

//   if (!retakes.length || !questions.length) {
//     return (
//       <div className="container mt-3 text-center">
//         <img className="logo-img bee" src={logo} alt="Bee's Care Ltd" />
//         <h2>No Retakes Found for this Training.</h2>
//       </div>
//     );
//   }

//   return (
//     <div className="container mt-4" style={{ fontFamily: "Arial, sans-serif", maxWidth: "800px" }}>
//       <div className="text-center mb-4">
//         <img className="logo-img bee" src={logo} alt="Bee's Care Ltd" />
//         <h2>{trainingName} - Retake Results</h2>
//       </div>

//       {/* User's details */}
//       <div className="mb-3">
//         <label><strong>Name of Learner:</strong></label>
//         <input
//           type="text"
//           value={`${userDetails?.firstName} ${userDetails?.lastName || "Loading..."}`}
//           className="form-control"
//           readOnly
//         />
//       </div>

//       <div className="mb-3">
//         <label><strong>Organisation:</strong></label>
//         <input
//           type="text"
//           value="Bee's Care Ltd"
//           className="form-control"
//           readOnly
//         />
//       </div>

//       <div className="mb-3">
//         <label><strong>Course Date:</strong></label>
//         <input
//           type="text"
//           value={formatDate(retakes[0]?.completedAt) || "Loading..."}
//           className="form-control"
//           readOnly
//         />
//       </div>

//       {/* Retake Results */}
//       {retakes.map((retake, retakeIndex) => (
//         <div key={retakeIndex} className="mb-5">
//           <h4>Retake {retakeIndex + 1}</h4>
//           <p><strong>Score:</strong> {retake.score}</p>
//           <p><strong>Completed At:</strong> {retake.completedAt}</p>

//           {/* Render True/False or MCQ questions */}
//           {questions.map((question, index) => (
//             <div key={index} className="row">
//               {/* Render True/False Questions */}
//               {trainingType === "true_false" && (
//                 <div className="row">
//                   <div className={`col-8 ${retake.answers?.[question.id] !== question.answer ? "text-danger" : ""}`}>
//                     {question.text}
//                   </div>
//                   <div className="col-2 text-center">
//                     {retake.answers?.[question.id] === true || retake.answers?.[question.id] === false ? (
//                       <span className={retake.answers?.[question.id] === question.answer ? "text-success" : "text-danger"}>
//                         {retake.answers?.[question.id] ? "True" : "False"}
//                       </span>
//                     ) : (
//                       "Not answered"
//                     )}
//                   </div>
//                   <div className="col-2 text-center">
//                     <span className="text-success">
//                       {question.answer ? "True" : "False"}
//                     </span>
//                   </div>
//                 </div>
//               )}

//               {/* Render MCQ Questions */}
//               {trainingType !== "true_false" && question.options && question.options.length > 0 &&
//                 question.options.map((option, optionIndex) => {
//                   const isUserAnswer = retake.answers?.[question.id] === optionIndex;
//                   const isCorrectAnswer = question.correctOption === optionIndex;

//                   return (
//                     <div key={optionIndex} className="row">
//                       <div className={`col-8 ${isUserAnswer && !isCorrectAnswer ? 'text-danger' : ''}`}>
//                         <p>{optionIndex + 1}. {option}</p>
//                       </div>
//                       <div className="col-2 text-center">
//                         {isUserAnswer ? (
//                           <span className={isCorrectAnswer ? "text-success" : "text-danger"}>X</span>
//                         ) : ""}
//                       </div>
//                       <div className="col-2 text-center">
//                         {isCorrectAnswer ? (
//                           <span className="text-success">X</span>
//                         ) : ""}
//                       </div>
//                     </div>
//                   );
//                 })
//               }
//             </div>
//           ))}
//         </div>
//       ))}

//       <div className="text-center mt-4">
//         <p><strong>© Bee’s Care Ltd. All rights reserved.</strong></p>
//       </div>

//       <ToastContainer />
//     </div>
//   );
// };

// export default ViewRetakeTrainingResult;



























import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc, collection, getDocs } from "firebase/firestore";
import { db } from "../firebase"; // Import your Firestore configuration
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import trainer from "../assets/trainer.png"; // Assuming you have this asset for the logo
import logo from "../assets/logo.png";
import bismillah from "../assets/bismillah.png";

const ViewRetakeTrainingResult = () => {
  const { userId, trainingId } = useParams(); // Extract userId and trainingId from URL params
  const [retakes, setRetakes] = useState([]); // User's retake attempts
  const [questions, setQuestions] = useState([]); // Questions from training collection
  const [userDetails, setUserDetails] = useState(null); // User's details
  const [loading, setLoading] = useState(true);
  const [trainingName, setTrainingName] = useState("");
  const [trainingType, setTrainingType] = useState(""); // true/false or mcq

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // Fetch user details
        const userDocRef = doc(db, "users", userId);
        const userDocSnap = await getDoc(userDocRef);
        if (userDocSnap.exists()) {
          setUserDetails(userDocSnap.data());
        } else {
          toast.error("User not found!");
        }

        // Fetch retakes from Firestore
        const retakesCollectionRef = collection(db, "users", userId, "quizzes", trainingId, "retakes");
        const retakesSnapshot = await getDocs(retakesCollectionRef);

        // Fetch training details
        const trainingDoc = await getDoc(doc(db, "trainings", trainingId));
        if (trainingDoc.exists()) {
          setTrainingName(trainingDoc.data().name);
          setTrainingType(trainingDoc.data().type); // true_false or mcq
        } else {
          toast.error("Training not found!");
        }

        // Fetch questions for the training
        const questionsCollectionRef = collection(db, `trainings/${trainingId}/questions`);
        const questionsSnapshot = await getDocs(questionsCollectionRef);
        const questionsData = questionsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setQuestions(questionsData);

        if (!retakesSnapshot.empty) {
          const retakesData = retakesSnapshot.docs.map((doc) => doc.data().attempts || []);
          setRetakes(retakesData.flat()); // Flatten retakes array
        } else {
          toast.info("No retakes found.");
        }
      } catch (error) {
        toast.error("Error fetching data: " + error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [userId, trainingId]);

  const formatDate = (dateString) => {
    if (!dateString) return ''; // Handle empty or undefined date
    const date = new Date(dateString);  // Convert string to Date object

    const day = String(date.getDate()).padStart(2, '0');  // Get day and ensure 2 digits
    const month = String(date.getMonth() + 1).padStart(2, '0');  // Get month (0-based, so add 1) and ensure 2 digits
    const year = date.getFullYear();  // Get year

    return `${day}/${month}/${year}`;  // Return formatted date as dd/mm/yyyy
  };

  if (loading) {
    return (
      <div className="container mt-3 text-center">
        <img className="logo-img" src={trainer} alt="Bee's Care Ltd" />
        <h2>Loading Retake Results...</h2>
      </div>
    );
  }

  if (!retakes.length || !questions.length) {
    return (
      <div className="container mt-3 text-center">
        <img className="logo-img bee" src={logo} alt="Bee's Care Ltd" />
        <h2>No Retakes Found for this Training.</h2>
      </div>
    );
  }

  return (
    <div className="container mt-4" style={{ fontFamily: "Arial, sans-serif", maxWidth: "800px" }}>
      <div className="text-center mb-4">
        <img className="logo-img bee" src={logo} alt="Bee's Care Ltd" />
        <h2>{trainingName} - Retake</h2>
      </div>

      {/* User's details */}
      <div className="mb-3">
        <label><strong>Name of Learner:</strong></label>
        <input
          type="text"
          value={`${userDetails?.firstName} ${userDetails?.lastName || "Loading..."}`}
          className="form-control"
          readOnly
        />
      </div>

      <div className="mb-3">
        <label><strong>Organisation:</strong></label>
        <input
          type="text"
          value="Bee's Care Ltd"
          className="form-control"
          readOnly
        />
      </div>

      <div className="mb-3">
        <label><strong>Course Date:</strong></label>
        <input
          type="text"
          value={formatDate(retakes[0]?.completedAt) || "Loading..."}
          className="form-control"
          readOnly
        />
      </div>

      <p className="text-center imp">
        <span className="imp-text">IMPORTANT:</span> Learners need to get at least 75% correct (15 correct answers) to gain their certificate.
      </p>

      {/* Retake Results */}
      {retakes.map((retake, retakeIndex) => (
        <div key={retakeIndex} className="mb-5">
          {/* <h4>Retake {retakeIndex + 1}</h4> */}
          
          {/* <p><strong>Completed At:</strong> {retake.completedAt}</p> */}

          <h3>Your Score: {retake.score} / {questions.length}</h3>
          <p>Required Score for Passing: 15 / 20</p>

          {/* Render True/False or MCQ questions */}
          {questions.map((question, index) => (
            <div key={index} className={`question-container ${trainingType === "true_false" ? "true-false-class" : "mcqs-class"
            }`}>
              {/* Question Text */}
              {/* <div className="mb-2">
                <strong>{index + 1}. {question.text}</strong>
              </div> */}

              {/* Render header for non-True/False questions */}
              {trainingType !== "true_false" && (
                  <div className="row">
                    <div className="col-8">
                      <p><strong>{question.text}</strong></p>
                    </div>
                    <div className="col-2 text-center">
                      <p><strong>Your Answer</strong></p>
                    </div>
                    <div className="col-2 text-center">
                      <p><strong>Correct Answer</strong></p>
                    </div>
                  </div>
                )}

                {/* Render header for True/False questions only once */}
                {trainingType === "true_false" && index === 0 && (
                  <div className="row">
                    <div className="col-8">
                      <p><strong>Statement</strong></p>
                    </div>
                    <div className="col-2 text-center">
                      <p><strong>Your Answer</strong></p>
                    </div>
                    <div className="col-2 text-center">
                      <p><strong>Correct Answer</strong></p>
                    </div>
                  </div>
                )}


                

              {/* Render True/False Questions */}
              {trainingType === "true_false" && (
                <div className="row">
                  <div className={`col-8 ${retake.answers?.[question.id] !== question.answer ? "text-danger" : ""}`}>
                    {question.text}
                  </div>
                  <div className="col-2 text-center">
                    {retake.answers?.[question.id] === true || retake.answers?.[question.id] === false ? (
                      <span className={retake.answers?.[question.id] === question.answer ? "text-success" : "text-danger"}>
                        {retake.answers?.[question.id] ? "True" : "False"}
                      </span>
                    ) : (
                      "Not answered"
                    )}
                  </div>
                  <div className="col-2 text-center">
                    <span className="text-success">
                      {question.answer ? "True" : "False"}
                    </span>
                  </div>
                </div>
              )}

              {/* Render MCQ Questions */}
              {trainingType !== "true_false" && question.options && question.options.length > 0 &&
                question.options.map((option, optionIndex) => {
                  const isUserAnswer = retake.answers?.[question.id] === optionIndex;
                  const isCorrectAnswer = question.correctOption === optionIndex;

                  return (
                    <div key={optionIndex} className="row">
                      <div className={`col-8 ${isUserAnswer && !isCorrectAnswer ? 'text-danger' : ''}`}>
                        <p>{optionIndex + 1}. {option}</p>
                      </div>
                      <div className="col-2 text-center">
                        {isUserAnswer ? (
                          <span className={isCorrectAnswer ? "text-success" : "text-danger"}>X</span>
                        ) : ""}
                      </div>
                      <div className="col-2 text-center">
                        {isCorrectAnswer ? (
                          <span className="text-success">X</span>
                        ) : ""}
                      </div>
                    </div>
                  );
                })
              }
            </div>
          ))}
        </div>
      ))}



<div className="mt-3 learner-sign">
        <label><strong>Signature By Learner:</strong></label>
        <div>
          <img
            src={retakes[0].signature || trainer} // Default to trainer logo if signature is missing
            alt="User Signature"
            style={{ width: "300px", height: "143px", border: "1px solid #ccc" }}
          />
        </div>
      </div>

      <div className="mt-3 trainer-sign">
        <label><strong>Signature By Trainer:</strong></label>
        <div>
          <img
            src={bismillah} // Default to trainer logo if signature is missing
            alt="User Signature"
            style={{ width: "300px", height: "143px", border: "1px solid #ccc" }}
          />
        </div>
      </div>
      

      <div className="text-center mt-4">
        <p><strong>© Bee’s Care Ltd. All rights reserved.</strong></p>
      </div>

      <ToastContainer />
    </div>
  );
};

export default ViewRetakeTrainingResult;



